import { render, staticRenderFns } from "./SideBarActions.vue?vue&type=template&id=ca5e3c50&scoped=true&"
import script from "./SideBarActions.vue?vue&type=script&setup=true&lang=js&"
export * from "./SideBarActions.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca5e3c50",
  null
  
)

export default component.exports